export default __webpack_public_path__ + "static/media/ddebt_logo.770c74362dd43d7f83df.770c7436.png";